
import Vue from 'vue'
import UiFooter from '~/components/ui/footer/index.vue'
import UiHeader from '~/components/ui/header/index.vue'
import IconSymbol from '~/components/ui/icons/icon-symbol/index.vue'
import UiCookie from '~/components/ui/cookie/index.vue'

const globalFormProviderDefault = {
  modalSize: '',
  productList: [],
  typeId: 0,
  loanAmount: 0,
  loanTerm: 0,
  typeOfCard: '',
  isLong: false,
  formDefault: ''
}

export default Vue.extend({
  components: {
    UiFooter,
    UiHeader,
    IconSymbol,
    UiCookie
  },
  provide: function () {
    return {
      layoutProvider: this.layoutProvider,
      setLayoutProviderProperty: this.setLayoutProviderProperty,
      globalFormProvider: this.globalFormProvider,
      setGlobalFormProvider: this.setGlobalFormProvider,
      setGlobalFormProviderProperties: this.setGlobalFormProviderProperties
    }
  },
  data () {
    return {
      showCookie: false,
      layoutProvider: {
        formDefault: undefined
      },
      globalFormProvider: {
        modalSize: '',
        productList: [],
        typeId: 0,
        loanAmount: 0,
        loanTerm: 0,
        typeOfCard: '',
        isLong: false,
        formDefault: ''
      },
      isOpenFormModal: false
    }
  },

  watch: {
    '$route.query.form' (form?: string) {
      this.isOpenFormModal = form === `${this.globalFormProvider.typeId}`
    }
  },

  beforeMount () {
    if (this.$route.query.form) {
      this.$router.push({ query: { ...this.$route.query, form: undefined } })
    }
  },
  mounted () {
    const activeSession = this.$cookies.get('activeSession')
    if (!activeSession) {
      this.$cookies.set('activeSession', true)
      this.showCookie = true
    }

    if (!this.$config.devMode) {
      setTimeout(() => {
        // Yandex.Metrika counter
        const yaMetrika = document.createElement('script')
        yaMetrika.type = 'text/javascript'
        yaMetrika.innerHTML = `(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
            m[i].l=1*new Date();
            for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
            k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
            (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

            ym(${this.$config.metrikaId}, "init", {
                  clickmap:true,
                  trackLinks:true,
                  accurateTrackBounce:true,
                  webvisor:true,
                  ecommerce:"dataLayer"
            });`
        document.body.appendChild(yaMetrika)

        const yaMetrikaWatch = document.createElement('noscript')
        yaMetrikaWatch.innerHTML = `<div><img src="https://mc.yandex.ru/watch/${this.$config.metrikaId}" style="position:absolute; left:-9999px;" alt="" /></div>`
        document.body.appendChild(yaMetrikaWatch)

        // Top.Mail.Ru counter
        const topMailRu = document.createElement('script')
        topMailRu.type = 'text/javascript'
        topMailRu.innerHTML = `var _tmr = window._tmr || (window._tmr = []);
          _tmr.push({id: "3341312", type: "pageView", start: (new Date()).getTime()});
          (function (d, w, id) {
            if (d.getElementById(id)) return;
            var ts = d.createElement("script"); ts.type = "text/javascript"; ts.async = true; ts.id = id;
            ts.src = "https://top-fwz1.mail.ru/js/code.js";
            var f = function () {var s = d.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ts, s);};
            if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); }
          })(document, window, "tmr-code");`
        document.body.appendChild(topMailRu)

        const topMailRuWatch = document.createElement('noscript')
        topMailRuWatch.innerHTML =
          '<div><img src="https://top-fwz1.mail.ru/counter?id=3341312;js=na" style="position:absolute;left:-9999px;" alt="Top.Mail.Ru" /></div>'
        document.body.appendChild(topMailRuWatch)
      }, 1000)
    }
  },

  methods: {
    setLayoutProviderProperty (key: string, value: any) {
      this.$set(this.layoutProvider, key, value)
    },
    setGlobalFormProvider (key: string, value: any) {
      this.$set(this.globalFormProvider, key, value)
    },
    setGlobalFormProviderProperties (values: object) {
      const temp = {}
      Object.assign(temp, globalFormProviderDefault, values)
      for (const key in temp) {
        this.$set(this.globalFormProvider, key, temp[key])
      }
    },
    searchSections () {
      const originTree = [
        this.$static.staticTree?.find(
          (link: { code: string }) => link?.code === 'index'
        ) || {}
      ]

      if (!originTree.length) {
        return []
      }

      const sections: any[] = []

      while (originTree.length) {
        if (originTree?.[0]?.children?.length) {
          originTree.push(...originTree[0].children)
        }

        if (originTree?.[0]?.isSection) {
          sections.push({
            ...originTree?.[0],
            children: originTree?.[0]?.children?.filter(
              child => !child?.isSection
            )
          })
        }

        originTree.shift()
      }

      sections?.sort(
        (
          section1: { sectionSort: number },
          section2: { sectionSort: number }
        ) => section1?.sectionSort - section2?.sectionSort
      )

      sections.push({
        code: 'news',
        isSection: false,
        isUrl: false,
        sectionSort: -1,
        showByDefault: false,
        showInFooter: true,
        showInHeader: false,
        showInMenu: false,
        sortInMenu: sections?.length || 0,
        title: 'Новости',
        useIndexHeader: true,
        children: [],
        isNews: true
      })

      return sections
    }
  }
})
